import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import * as DialogActions from '../actions/Dialog';
import * as PasswordActions from '../actions/Password';
import ForgotPasswordForm from '../components/ForgotPasswordForm';

// componentのsignFormとの連係
const selector = formValueSelector('forgotPasswordForm');

const mapStateToProps = (state: any) => {
  const username = selector(state, 'username');
  return {
    auth: state.auth,
    forgotPasswordForm: {
      username,
    }
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    dialogActions: bindActionCreators(DialogActions, dispatch),
    passwordActions: bindActionCreators(PasswordActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ForgotPasswordForm as any);



// WEBPACK FOOTER //
// ./src/containers/ForgotPasswordForm.tsx